import { CALL_CSR_API } from '../../middleware/authHeaders'
import { CSR_API_ROOT } from '../../config/api'

export const CSR_GET_ROLES_REQUEST = 'CSR_GET_ROLES_REQUEST'
export const CSR_GET_ROLES_SUCCESS = 'CSR_GET_ROLES_SUCCESS'
export const CSR_GET_ROLES_FAILURE = 'CSR_GET_ROLES_FAILURE'

export const getCsrRoles = () => dispatch =>
  dispatch({
    [CALL_CSR_API]: {
      method: 'GET',
      endpoint: `${CSR_API_ROOT}/roles`,
      types: [CSR_GET_ROLES_REQUEST, CSR_GET_ROLES_SUCCESS, CSR_GET_ROLES_FAILURE],
    },
  })

// SELECTORS
export const selectCsrRoles = state => state.csr.authorization.roles

// STATE
export const INITIAL_STATE = {
  roles: null,
}

// REDUCER
const authorization = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [CSR_GET_ROLES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      roles: newPayload?.results,
    }),
  }[type]?.(state, payload) || state)

export default authorization
